export default __webpack_public_path__ + "static/media/no-camera.60415650.svg";